
import Http from 'services/http';
// TODO - Make type for the new arrivals or simply use the instruments type again.

const api = new Http({ host: process.env.API_URL });

export class VintageNewArrivalsApi {
    public static getNewArrivals(): Promise<any> {
        return api.get('/api/instruments/vintage-new-arrivals');
    }
}



// WEBPACK FOOTER //
// ./src/providers/VintageNewArrivalsApi.ts